import { render, staticRenderFns } from "./InvoiceControlView.vue?vue&type=template&id=b861281e&scoped=true"
import script from "./InvoiceControlView.vue?vue&type=script&lang=js"
export * from "./InvoiceControlView.vue?vue&type=script&lang=js"
import style0 from "./InvoiceControlView.vue?vue&type=style&index=0&id=b861281e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b861281e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b861281e')) {
      api.createRecord('b861281e', component.options)
    } else {
      api.reload('b861281e', component.options)
    }
    module.hot.accept("./InvoiceControlView.vue?vue&type=template&id=b861281e&scoped=true", function () {
      api.rerender('b861281e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/InvoiceControlView.vue"
export default component.exports